import { createBrowserRouter, Navigate } from 'react-router-dom'
import { AppLayout } from '@/components/layout/AppLayout'
import { ProtectedRoute } from '@/components/shared/ProtectedRoute'
import { LoginPage } from '@/pages/auth/LoginPage'
import { HomePage } from '@/pages/home/HomePage'
import { DashboardPage } from '@/pages/dashboard/DashboardPage'
import { ClientsListPage } from '@/pages/clients/ClientsListPage'
import { ClientFormPage } from '@/pages/clients/ClientFormPage'
import { UsersPage } from '@/pages/users/UsersPage'
import { WasteTypesPage } from '@/pages/waste-types/WasteTypesPage'
import { PickupsCalendarPage } from '@/pages/pickups/PickupsCalendarPage'
import { PickupFormPage } from '@/pages/pickups/PickupFormPage'
import { PickupDetailPage } from '@/pages/pickups/PickupDetailPage'
import { RecordFormPage } from '@/pages/records/RecordFormPage'
import { SyncPage } from '@/pages/SyncPage'
import { DestinationsPage } from '@/pages/destinations/DestinationsPage'
import { DeliveryFormPage } from '@/pages/deliveries/DeliveryFormPage'
import { DeliveryDetailPage } from '@/pages/deliveries/DeliveryDetailPage'
import { EsgReportPage } from '@/pages/reports/EsgReportPage'

export const router = createBrowserRouter([
  // Ruta pública
  {
    path: '/login',
    element: <LoginPage />,
  },

  // Rutas protegidas
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          // Inicio (todos los roles)
          {
            path: '/',
            element: <Navigate to="/home" replace />,
          },
          {
            path: '/home',
            element: <HomePage />,
          },

          // Dashboard de indicadores (solo admin)
          {
            element: <ProtectedRoute allowedRoles={['admin']} />,
            children: [
              {
                path: '/dashboard',
                element: <DashboardPage />,
              },
            ],
          },

          // Clientes y tipos de residuo (solo admin)
          {
            element: <ProtectedRoute allowedRoles={['admin']} />,
            children: [
              {
                path: '/clients',
                element: <ClientsListPage />,
              },
              {
                path: '/clients/new',
                element: <ClientFormPage />,
              },
              {
                path: '/clients/:id/edit',
                element: <ClientFormPage />,
              },
              {
                path: '/users',
                element: <UsersPage />,
              },
              {
                path: '/waste-types',
                element: <WasteTypesPage />,
              },
              {
                path: '/destinations',
                element: <DestinationsPage />,
              },
            ],
          },

          // Retiros (admin y operator)
          {
            element: <ProtectedRoute allowedRoles={['admin', 'operator']} />,
            children: [
              {
                path: '/pickups',
                element: <PickupsCalendarPage />,
              },
              {
                path: '/pickups/new',
                element: <PickupFormPage />,
              },
              {
                path: '/pickups/:id',
                element: <PickupDetailPage />,
              },
              {
                path: '/pickups/:id/edit',
                element: <PickupFormPage />,
              },
              {
                path: '/pickups/:id/record',
                element: <RecordFormPage />,
              },
            ],
          },

          // Entregas a disposición final (admin y operator)
          {
            element: <ProtectedRoute allowedRoles={['admin', 'operator']} />,
            children: [
              {
                path: '/deliveries/new',
                element: <DeliveryFormPage />,
              },
              {
                path: '/deliveries/:id/edit',
                element: <DeliveryFormPage />,
              },
            ],
          },

          // Detalle de entrega (solo admin)
          {
            element: <ProtectedRoute allowedRoles={['admin']} />,
            children: [
              {
                path: '/deliveries/:id',
                element: <DeliveryDetailPage />,
              },
            ],
          },

          // Informes ESG (solo admin)
          {
            element: <ProtectedRoute allowedRoles={['admin']} />,
            children: [
              {
                path: '/reports/esg',
                element: <EsgReportPage />,
              },
            ],
          },

          // Sincronización (admin y operator)
          {
            element: <ProtectedRoute allowedRoles={['admin', 'operator']} />,
            children: [
              {
                path: '/sync',
                element: <SyncPage />,
              },
            ],
          },
        ],
      },
    ],
  },

  // Ruta de fallback
  {
    path: '*',
    element: <Navigate to="/home" replace />,
  },
])
